import * as React from "react";
import { connect } from "react-redux";

import ResponsiveImage from "../controls/ResponsiveImage";

import { IState, IAppSettings } from "../../state/state";

export interface IHowItWorksEliminationProps {
    appSettings: IAppSettings | null;
}

const HowItWorksElimination = (props: IHowItWorksEliminationProps) => {

    const seasonLabel = props.appSettings?.currentSeasonName
        ? `NFL ${props.appSettings.currentSeasonName}`
        : "the current NFL season";

    return (<div>
        <h3 className="tight-panel"><img src="/img/new/picks-32x32.png" className="icon32" alt=""/> Make Your Picks (Elimination)</h3>
        <div className="content-panel">
            <p>For each Elimination league, make ONE pick per week. Previously picked teams are grayed out. If no pick is made before the first weekend game locks (Wednesday and Thursday games lock individually), you are assigned the default pick for that week.</p>
            <ResponsiveImage fileName="elimination-pick.png" />
            <p>The only season available right now is {seasonLabel}. You pick ONE game, every week, straight up.</p>
            <p>You stay in the league if your pick is right - otherwise - ELIMINATION!</p>
        </div>

        <h3 className="tight-panel"><img src="/img/new/view-32x32.png" className="icon32" alt=""/> View the Results (Elimination)</h3>
        <div className="content-panel">
            <p>Results are populated in real time. (OK, it's delayed a minute or so...)</p>
            <ResponsiveImage fileName="elimination-results.png" />
        </div>

        <h3 className="tight-panel"><img src="/img/new/check-list-32x32.png" className="icon32" alt=""/> Check the Standings (Elimination)</h3>
        <div className="content-panel">
            <p>Check out those standing and behold the glory. You survived! Or not.</p>
            <ResponsiveImage fileName="elimination-standings.png" />
        </div>
    </div>);
};

function mapStateToProps(state: IState): IHowItWorksEliminationProps {
    return {
        appSettings: state.appSettings
    };
}

export default connect(mapStateToProps)(HowItWorksElimination as any);
